import { GetStaticProps, NextPage } from "next";
import Layout from "@common/layout";
import React from "react";
import { wrapper } from "@redux/index";
import { getAppSettings, setApp } from "@redux/app/actions";
import { EPage, TLang } from "@common/types";
import { END } from "redux-saga";
import { getContacts } from "@redux/contacts/actions";
import { useTypedSelector } from "@common/hooks/useTypedSelector";
import { getExpertisePage } from "@redux/expertise/actions";
import { Expertise } from "@modules/Expertise";

const ExpertisePage: NextPage = () => {
  const { expertisePage } = useTypedSelector((state) => state.expertise);

  return (
    <Layout
      title={expertisePage?.meta?.title}
      description={expertisePage?.meta?.description}
      pipelineId={expertisePage?.meta?.pipelineId}
    >
      <Expertise />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
  (store) =>
    async ({ ...etc }) => {
      const locale = etc.locale as TLang;
      store.dispatch(
        setApp({
          page: EPage.EXPERTISE_PAGE,
          draftMode: etc.draftMode ?? false,
          locale,
        })
      );
      store.dispatch(getAppSettings({ locale }));
      store.dispatch(getContacts({ locale }));
      store.dispatch(getExpertisePage({ locale }));
      store.dispatch(END);
      await store?.sagaTask.toPromise();

      return {
        props: {},
      };
    }
);

export default ExpertisePage;
